__turbopack_context__.v({
  "Layout": "PageLayout-module-scss-module__f5OZNG__Layout",
  "Logo": "PageLayout-module-scss-module__f5OZNG__Logo",
  "MerchantLogo": "PageLayout-module-scss-module__f5OZNG__MerchantLogo",
  "Wrapper": "PageLayout-module-scss-module__f5OZNG__Wrapper",
});
